<template>
	<modal ref="modal">
		<template #title>Edit Material</template>
		<template #body>
			<div
				v-if="material"
				class="block"
				:class="{ 'block-mode-loading': form.processing }"
			>
				<div class="row">
					<div class="col-lg-4 col-md-12 mb-4">
						<div class="mb-4">
							<label class="form-label" for="avatar">Banner</label>
							<input
								@change="onFileChange"
								type="file"
								id="edit-banner"
								class="form-control"
								accept="image/*"
							/>
						</div>
						<div
							v-if="form.card"
							class="overflow-hidden rounded text-center bg-body-light border-start border-primary border-4"
							:class="{ 'opacity-25': form.updated_banner }"
							:style="'background-image:url(' + form.card + ')'"
							style="
								height: 200px;
								background-size: contain;
								background-repeat: no-repeat;
								background-position: center;
							"
						/>
						<div v-if="form.updated_banner">
							<div class="text-center text-muted">
								<i class="fa fa-arrow-down fa-2x"></i>
							</div>
							<div
								id="edit-banner-preview-2"
								class="overflow-hidden rounded mb-3 text-center bg-body-light border-start border-info border-4"
								style="
									height: 200px;
									background-size: contain;
									background-repeat: no-repeat;
									background-position: center;
								"
							/>
							<div class="text-center">
								<button
									@click="remove_banner"
									type="button"
									class="btn btn-alt-danger btn-sm"
								>
									Remove
								</button>
							</div>
						</div>
					</div>
					<div class="col">
						<div class="mb-4">
							<label class="form-label">Title</label>
							<input
								v-model="form.title"
								type="text"
								class="form-control"
								:class="{ 'is-invalid': form.errors.title }"
							/>
							<div v-if="form.errors.title" class="invalid-feedback">
								{{ form.errors.title }}
							</div>
						</div>
						<div class="mb-4">
							<label class="form-label">Category</label>
							<select
								v-model="form.category"
								class="form-select"
								:class="{ 'is-invalid': form.errors.category }"
							>
								<option :value="null" selected>SELECT CATEGORY</option>
								<option
									v-for="(
										category, key, index
									) in collection.material_categories"
									:key="index"
									:value="key"
								>
									{{ category }}
								</option>
							</select>
							<div v-if="form.errors.category" class="invalid-feedback">
								{{ form.errors.category }}
							</div>
						</div>
						<div class="row">
							<div class="col">
								<div class="mb-4">
									<label class="form-label">Video Host</label>
									<select
										v-model="form.video_host"
										class="form-select"
										:class="{ 'is-invalid': form.errors.video_host }"
									>
										<option :value="null" selected>SELECT VIDEO HOST</option>
										<option
											v-for="(video_host, key, index) in collection.video_hosts"
											:key="index"
											:value="key"
										>
											{{ video_host }}
										</option>
									</select>
									<div v-if="form.errors.video_host" class="invalid-feedback">
										{{ form.errors.video_host }}
									</div>
								</div>
							</div>
							<div class="col">
								<div class="mb-4">
									<label class="form-label">Video ID</label>
									<input
										v-model="form.video_id"
										type="text"
										class="form-control"
										:class="{ 'is-invalid': form.errors.video_id }"
									/>
									<div v-if="form.errors.video_id" class="invalid-feedback">
										{{ form.errors.video_id }}
									</div>
								</div>
							</div>
						</div>
						<div class="mb-4">
							<label class="form-label">Message</label>
							<textarea
								v-model="form.message"
								class="form-control"
								rows="5"
							></textarea>
						</div>
						<div class="row">
							<div class="col-md-6">
								<div class="mb-4">
									<label class="form-label">
										Material
										<small class="text-muted">(PDF File)</small>
									</label>
									<input
										@change="handlePdfChange"
										type="file"
										id="edit-pdf"
										class="form-control"
										:class="{ 'is-invalid': form.errors.pdf }"
										accept="application/pdf"
									/>
									<div v-if="form.errors.pdf" class="invalid-feedback">
										{{ form.errors.pdf }}
									</div>
									<div v-if="form.pdf" class="mt-3">
										<a
											:href="material.pdf_url"
											class="text-muted"
											target="_blank"
										>
											<i class="far fa-file-pdf me-1 text-pulse"></i>
											{{ form.pdf }}
										</a>
									</div>
								</div>
							</div>
							<div class="col-md-6">
								<div class="mb-4">
									<label class="form-label">Scheduled Post</label>
									<flat-pickr
										v-model="form.date_appear"
										:config="{
											enableTime: true,
											altInput: true,
											altFormat: 'M j, Y h:i K',
											dateFormat: 'Y-m-d H:i:s',
										}"
										class="form-control"
										:class="
											form.errors.date_appear
												? 'flatpickr-input is-invalid border-danger'
												: 'flatpickr-input'
										"
									/>
									<div v-if="form.errors.date_appear" class="invalid-feedback">
										{{ form.errors.date_appear }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template #footer>
			<button
				@click="submit"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				<i class="fa fa-save me-2"></i>Save Changes
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				<i class="fa fa-times"></i>Close
			</button>
		</template>
	</modal>
</template>

<script>
import { ref, watch } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	props: {
		material: Object,
		collection: Object,
	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()

			const banner_file = document.getElementById('edit-banner')
			if (banner_file && banner_file.files.length > 0) {
				banner_file.value = null
			}
		}

		const form = useForm({
			id: null,
			card: null,
			title: null,
			category: null,
			video_host: null,
			video_id: null,
			message: null,
			pdf: null,
			date_appear: null,
			updated_banner: null,
			updated_pdf: null,
			_method: 'PUT',
		})

		const onFileChange = (e) => {
			if (e.target.files.length > 0) {
				form.updated_banner = e.target.files[0]

				setTimeout(function () {
					const src = URL.createObjectURL(e.target.files[0])
					const banner_preview2 = document.getElementById(
						'edit-banner-preview-2'
					)
					banner_preview2.style.backgroundImage = `url(${src})`
				}, 100)
			} else {
				form.updated_banner = null
			}
		}

		const handlePdfChange = (e) => {
			if (e.target.files.length > 0) {
				form.updated_pdf = e.target.files[0]
			} else {
				form.updated_pdf = null
			}
		}

		const submit = () => {
			form.post(route('admin.site-management.user-materials.update', form.id), {
				forceFormData: true,
				preserveState: true,
				preserveScroll: true,
				only: ['materials','api_response','errors'],
				onSuccess: () => {
					form.reset()
					toggleModal()
					document.getElementById('edit-banner').value = null
					document.getElementById('edit-pdf').value = null
				}
			})
		}

		const remove_banner = () => {
			form.updated_banner = null
			document.getElementById('edit-banner').value = null
		}

		watch(
			() => props.material,
			(material) => {
				if (material) {
					form.id = material.id
					form.title = material.title
					form.category = material.category
					form.card = material.card
					form.date_appear = material.date_appear
					form.video_id = material.video_id
					form.video_host = material.video_host
					form.message = material.message
					form.pdf = material.pdf
					form.updated_banner = null
					form.updated_pdf = null
					form.defaults()
				}
			}
		)

		return {
			form,
			modal,
			submit,
			toggleModal,
			onFileChange,
			remove_banner,
			handlePdfChange,
		}
	},
}
</script>
